var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CheckListTableComponent',{attrs:{"typeName":"巡回清掃","type":2,"routerName":"RoundScheduleListByStaff","siteLocation":_vm.siteLocation,"rls":_vm.rls}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }